import { ReservationDataService } from '@/common/services/details/details.service';
import { CancelationInterface } from '@/core/domain/cancelation/models/cancelation.model';
import { DetailsInterface } from '@/core/domain/details/models/details.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import Swal from 'sweetalert2';
import { CancelationService } from '@/common/services/cancelation/cancelation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GtmRefundUseCase } from '@/core/domain/gtm/usecases/gtmRefund.usecase';
import { UrlService } from '@/common/services/url/url.service';

@Component({
    selector: 'fe-cancel-reservation',
    templateUrl: './cancel-reservation.component.html',
    styleUrls: ['./cancel-reservation.component.scss'],
})
export class CancelReservationComponent implements OnInit {
    code!: string;
    lastName!: string;
    reservationDetails: DetailsInterface | null = null;
    public confirmButtonText?: string;
    public cancelButtonText?: string;

    public isCanceled = false;

    loadingBtn = false;

    @ViewChild('cancelTemplate') private cancelSwal!: SwalComponent;

    constructor(
        private translate: TranslateService,
        private reservationDataService: ReservationDataService,
        private cancelationService: CancelationService,
        private route: ActivatedRoute,
        private router: Router,
        private url: UrlService,
        private readonly gtmRefundUseCase: GtmRefundUseCase,
    ) {}

    ngOnInit(): void {
        this.code =
            this.route.snapshot.queryParamMap.get('reservationCode') || '';
        this.lastName = this.route.snapshot.queryParamMap.get('lastName') || '';

        this.reservationDataService.getDetails().subscribe((details) => {
            this.reservationDetails = details;
        });
    }

    swal() {
        if (
            !this.reservationDetails ||
            this.reservationDetails.data?.reservationDetails.cancelationDate ||
            this.isCanceled
        ) {
            return;
        }

        const confirmButtonText = this.translate.instant(
            'fe_details_step5_cancel_template_confirm_button_text',
        );
        const cancelButtonText = this.translate.instant(
            'fe_details_step5_cancel_template_cancel_button_text',
        );
        const cancelationSuccess = this.translate.instant(
            'fe_details_step5_cancel_template_cancelation_success',
        );
        const cancelationError = this.translate.instant(
            'fe_details_step5_cancel_template_cancelation_error',
        );

        this.cancelSwal.update({
            confirmButtonText,
            cancelButtonText,
        });

        this.cancelSwal.fire().then((result) => {
            if (result.isConfirmed) {
                this.loadingBtn = true;
                this.gtmRefundUseCase.execute(this.code as string).subscribe();
                this.cancelationService
                    .cancelReservation({
                        reservationCode: this.code,
                        lastName: this.lastName,
                    })
                    .subscribe({
                        next: () => {
                            Swal.fire(cancelationSuccess, '', 'success');
                            this.loadingBtn = false;
                            this.isCanceled = true;
                            this.reload();
                        },
                        error: () => {
                            Swal.fire(cancelationError, '', 'error');
                            this.loadingBtn = false;
                        },
                    });
            }
        });
    }

    reload() {
        setTimeout(() => {
            window.location.reload();
        }, 1000);
    }
}
